import { configureStore } from "@reduxjs/toolkit";
import { api } from "store/api/rtkApi";
import RootReducer from "store/root";

export const store = configureStore({
	devTools: true,
	reducer: RootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({}).concat(api.middleware),
});
